<template>
  <fieldset>
    <div v-for="(option, index) in options" :key="name + '-' + index" class="radio-inline">
      <Field
        :id="name + '-option-' + index"
        :value="option.Value"
        v-model="model"
        :rules="'required_radio'"
        :name="name + '-option'"
        type="radio"
        class="checkbox-style"
        @change="
          (event) => {
            $emit('update:modelValue', event.target._value);
          }
        "
        @click="clickInputCheckboxBehavior($event)"
      />
      <label class="paragraph-text-large" :for="name + '-option-' + index" v-html="option.Text" />
    </div>
    <ValidationError :name="name + '-option'" data-test="validation-cpr-consent" class="warning" />
  </fieldset>
</template>

<script>
import ValidationError from '@/components/UI/ValidationError.vue';
import { Field } from 'vee-validate';
import { defineRule } from 'vee-validate';

export default {
  name: 'RadioButtonsCheckBoxStyle',
  data() {
    return {
      model: null
    };
  },
  props: {
    modelValue: {
      type: Boolean,
      default() {
        return null;
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    name: {
      type: String,
      default() {
        return null;
      }
    },
    requiredValidationOverride: {
      type: String,
      default() {
        return 'Skal udfyldes';
      }
    }
  },
  created() {
    defineRule('required_radio', (value) => {
      if (value === null) return this.requiredValidationOverride;
      return true;
    });
  },
  watch: {
    modelValue(val) {
      this.model = val;
    }
  },
  mounted() {
    this.model = this.modelValue;
  },
  methods: {
    clickInputCheckboxBehavior(event) {
      if (this.model !== null && event.target.value === this.model.toString()) {
        this.model = null;
        this.$emit('update:modelValue', this.model);
      }
    }
  }
};
</script>
